// extracted by mini-css-extract-plugin
export default {"manageModalContainer":"PersonalisedMenteeEmailersManageModal_manageModalContainer__8MlSB"};